var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { colors } from '../../../theme';
export var PaymentOptionsBannerWrapper = styled(Inset)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-width: 1px 0;\n  border-style: solid;\n  border-color: ", ";\n"], ["\n  background-color: ", ";\n  border-width: 1px 0;\n  border-style: solid;\n  border-color: ", ";\n"])), colors.lightTurquoise, colors.lightGrey);
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map